import React from "react";
import { motion } from "framer-motion";

const Paragraph = ({
  infoObjectName,
  path,
  name,
  data,
  rendererOptions: { hideKeys, color },
}) => {
  const paragraphStyle = {
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    fontSize: "0.875rem",
    color: color || "inherit",
    maxWidth: "100%",
    overflow: "hidden",
    margin: 0,
  };

  return (
    <motion.p
      style={paragraphStyle}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      data-renderer="paragraph"
    >
      {data?.toString() || ""}
    </motion.p>
  );
};

export default Paragraph;
